/**
 * video-js-api參考
 * https://blog.csdn.net/a0405221/article/details/80923090  videojs中文文档详解_谢泽的网络日志-CSDN博客_videojs
 * https://docs.videojs.com/tutorial-player-workflows.html  Video.js Documentation
 * https://blog.csdn.net/zhangjing0320/article/details/108004243   videojs在vue中的应用_混世小妲己-CSDN博客
 */
import Vue from 'vue'
import Video from 'video.js'
import cn from 'video.js/dist/lang/zh-CN.json'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { ACCESS_TOKEN } from '@/store/mutation-types'

Vue.use(Viewer)

export default {
  data () {
    return {
      images: [],
      videos: []
    }
  },
  directives: {
    'loaded': {
      bind: function (el, binding, vnode) {
        el.innerHTML = binding['value'].replace(/href="(http:\/\/|https:\/\/|)/g, 'href="//')
        let vm = vnode.context
        setTimeout(() => {
          vm.initVideo()
          vm.imgAddListen(el)
          vm.linkReplace(el)
        })
      }
    }
  },
  methods: {
    initVideo () {
      let index = 0
      for (let videoItem of document.getElementsByTagName('video')) {
        // console.dir('videoItem', videoItem)
        videoItem.setAttribute('id', 'video' + index++)
        videoItem.className += ' video-js'
        this.videos.push(Video(videoItem, {
          playbackRates: [0.5, 1, 1.5, 2],
          language: 'zh-CN'
        }))
      }
      Video.addLanguage('zh-CN', cn)
    },
    imgAddListen (wrap) {
      for (let img of wrap.getElementsByTagName('img')) {
        let fun = () => {
          this.videos.map(item => item.pause())
        }
        img.style.height = 'auto'
        img.addEventListener('click', fun)
        this.$once('hook:beforeDestroy', function () {
          img.removeEventListener('click', fun)
        })
      }
    },
    linkReplace (wrap) {
      const parmas = `source=sso&token=${this.$ls.get(ACCESS_TOKEN)}`
      for (let link of wrap.getElementsByTagName('a')) {
        if ('source_sso'.includes(link.classList)) {
          link.href += (/\?/g.test(link.href) ? '&' : '?') + parmas
        }
      }
    }
  }
}
